// extracted by mini-css-extract-plugin
export default {"style":"FormulaireAxe_style__CiyHq","input":"FormulaireAxe_input__xpxNW","borderr":"FormulaireAxe_borderr__utCaC","styleTitle":"FormulaireAxe_styleTitle__ZPJwL"};